function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { head, isNil, pathOr, pluck, reject } from 'ramda';
import moment from 'moment';
import { stateGo } from 'redux-ui-router';
import { PRODUCT_CLASSIFICATIONS } from 'invision-core/src/constants/product.constants';
import { IsDbss } from 'invision-core/src/components/session/businessunit.selectors';
import i18n from 'invision-core/src/components/i18n/i18n';
import { fetchProductLineOfBusinessDeliveryCapabilityConfigurationAction } from 'invision-core/src/components/metadata/codes/codes.actions';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { MetadataCodeLoadedSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { UserSecurityAttributesSelector } from 'invision-core/src/components/session/session.selectors';
import { hasAdminAccess, hasAccess } from 'invision-core/src/components/security/permission.service';
import LocaleKeys from './../../../../locales/keys';
import { NOTIFICATION_TIME_LENGTH } from '../../../../customercare.constants';
import { END_DATE_TYPES } from '../../../../reducers/constants/dashboard.constants';
import { GRANT_ADDITIONAL_RIGHTS, ORDERING_ACCESS } from '../../../../security.attributes';
import { CurrentCustomerIdSelector, CurrentCustomerSelector, RouteParams, RouteState } from '../../../../reducers/selectors/customer.selectors';
import { DETAIL_STATE_OR_NAME as CONTENT_ACTIVITY_STATE } from '../../contentActivity/content.activity.config';
import { IsRemovingProductSelector } from '../../../../reducers/selectors/customer.products.selectors';
import { CanViewContentActivitySelector, CurrentLockerItemIdSelector, CurrentLockerItemOrderIdSelector, CurrentProductDetailSelector, CurrentProductDetailsClassificationSelector, CurrentProductOrderDetailSelector, CurrentProductServiceIdSelector, CurrentOfferInContextSelector, IsFetchingProductDetailDataSelector } from '../../../../reducers/selectors/customer.product.detail.selectors';
import { retrieveOrderForLockerDetail, retrieveProductDetail } from '../../../../reducers/actions/customer.product.detail.actions';
import { IsFetchingAccountDetailsSelector } from '../../../../reducers/selectors/customer.convergent.biller.selectors';
import { retrieveConvergentBillerAccountDetails } from '../../../../reducers/actions/customer.convergent.biller.actions';
import { isProductEditable } from '../products.component.helpers';
var MORE_OPTIONS_IDENTIFIER = {
  REMOVE: 0
};
var ProductsDetailController = /*#__PURE__*/function () {
  function ProductsDetailController($ngRedux, $timeout, uiNotificationService) {
    _classCallCheck(this, ProductsDetailController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $timeout: $timeout,
      isProductLoadComplete: false,
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(ProductsDetailController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          canViewContentActivity: CanViewContentActivitySelector(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          currentCustomer: CurrentCustomerSelector(store),
          deliveryCapabilityConfigurationLoaded: MetadataCodeLoadedSelector(CODES.ProductLineOfBusinessDeliveryCapabilityConfigurationAction, store),
          currentLockerItemId: CurrentLockerItemIdSelector(store),
          currentLockerItemOrderId: CurrentLockerItemOrderIdSelector(store),
          currentProductServiceId: CurrentProductServiceIdSelector(store),
          currentOfferInContext: CurrentOfferInContextSelector(store),
          currentOrderDetail: CurrentProductOrderDetailSelector(store),
          isDbss: IsDbss(store),
          isFetchingAccountDetails: IsFetchingAccountDetailsSelector(store),
          isFetchingProductDetail: IsFetchingProductDetailDataSelector(store),
          isRemovingProduct: IsRemovingProductSelector(store),
          productDetail: CurrentProductDetailSelector(store),
          productClassification: CurrentProductDetailsClassificationSelector(store),
          routeParams: RouteParams(store),
          routeState: RouteState(store),
          userSecurityAttributes: UserSecurityAttributesSelector(store)
        };
      };
      var controllerActions = {
        fetchDeliveryCapabilityConfiguration: fetchProductLineOfBusinessDeliveryCapabilityConfigurationAction,
        retrieveConvergentBillerAccountDetails: retrieveConvergentBillerAccountDetails,
        retrieveOrderForLockerDetail: retrieveOrderForLockerDetail,
        retrieveProductDetail: retrieveProductDetail,
        stateGo: stateGo
      };
      this.disconnect = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.offerEndDateTypes = END_DATE_TYPES;
      this.CustomerLocaleKeys = LocaleKeys;
      this.stateOrName = 'index.customercare.customer.products.detail';
      this.actions.retrieveProductDetail(this.state.currentCustomerId, this.state.currentLockerItemId).then(function (response) {
        _this.isProductLoadComplete = true;
        if (_this.state.isDbss) {
          _this.actions.retrieveConvergentBillerAccountDetails(_this.state.currentCustomerId).then(function () {
            if (pathOr(null, ['LockerItem', 'Product', 'ProductClassification'], response) === PRODUCT_CLASSIFICATIONS.SERVICE_FEATURE) {
              _this.setServiceName();
            }
          });
        }
        _this.actions.retrieveOrderForLockerDetail(_this.state.currentCustomerId, _this.state.currentLockerItemOrderId);
        _this.moreOptions = _this.buildMoreOptions();
      });
      if (!this.state.deliveryCapabilityConfigurationLoaded) {
        this.actions.fetchDeliveryCapabilityConfiguration();
      }
      this.hasGrantAdditionalRightsAccess = this.canGrantAdditionalRights();
      this.grantAccessRightsPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref) {
          var api = _ref.api;
          _this.grantAccessRightsPopupConfig = api;
        }
      };
      this.removeProductsPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref2) {
          var api = _ref2.api;
          _this.removeProductsPopupConfig = api;
        }
      };
      this.currentDateTime = new Date();
    }
  }, {
    key: "$onChanges",
    value: function $onChanges() {
      if (this.state) {
        this.moreOptions = this.buildMoreOptions();
      }
    }
  }, {
    key: "setServiceName",
    value: function setServiceName() {
      var _this2 = this;
      var service = this.state.productDetail.Product.Services.find(function (service) {
        return service.Id === _this2.state.currentProductServiceId;
      });
      this.ServiceName = service ? service.Name : null;
    }
  }, {
    key: "buildMoreOptions",
    value: function buildMoreOptions() {
      var hasOrderingAdminAccess = hasAdminAccess(this.state.userSecurityAttributes, ORDERING_ACCESS);
      var moreOptions = [];
      if (hasOrderingAdminAccess && isProductEditable(this.state.productDetail, this.state.isDbss)) {
        moreOptions.push({
          title: i18n.translate(this.CustomerLocaleKeys.REMOVE),
          id: MORE_OPTIONS_IDENTIFIER.REMOVE
        });
      }
      return moreOptions;
    }
  }, {
    key: "handleOptionSelected",
    value: function handleOptionSelected(_ref3) {
      var id = _ref3.item.id;
      switch (id) {
        case MORE_OPTIONS_IDENTIFIER.REMOVE:
          this.openRemoveProductsPopup();
          break;
        default:
          break;
      }
    }
  }, {
    key: "submitGrantAccessRightsPopup",
    value: function submitGrantAccessRightsPopup() {
      this.closeGrantAccessRightsPopup();
      this.actions.retrieveProductDetail(this.state.currentCustomerId, this.state.currentLockerItemId);
      this.uiNotificationService.success(i18n.translate(this.CustomerLocaleKeys.GRANT_ACCESS.SUCCESSFULLY_UPDATED), null, {
        timeout: NOTIFICATION_TIME_LENGTH
      });
    }
  }, {
    key: "closeGrantAccessRightsPopup",
    value: function closeGrantAccessRightsPopup() {
      this.grantAccessRightsPopupConfig.close();
      this.showGrantAccessModal = false;
    }
  }, {
    key: "openGrantAccessRightsPopup",
    value: function openGrantAccessRightsPopup(policy) {
      var _this3 = this;
      this.selectedPolicy = policy;
      this.showGrantAccessModal = true;
      this.$timeout(function () {
        _this3.grantAccessRightsPopupConfig.open();
      });
    }
  }, {
    key: "submitRemoveProductsPopup",
    value: function submitRemoveProductsPopup() {
      this.closeRemoveProductsPopup();
      this.actions.retrieveProductDetail(this.state.currentCustomerId, this.state.currentLockerItemId);
    }
  }, {
    key: "closeRemoveProductsPopup",
    value: function closeRemoveProductsPopup() {
      this.removeProductsPopupConfig.close();
      this.showRemoveProductsPopup = false;
    }
  }, {
    key: "openRemoveProductsPopup",
    value: function openRemoveProductsPopup() {
      var _this4 = this;
      this.showRemoveProductsPopup = true;
      this.$timeout(function () {
        _this4.removeProductsPopupConfig.open();
      });
    }
  }, {
    key: "navigateToOrderDetails",
    value: function navigateToOrderDetails() {
      this.actions.stateGo('index.customercare.customer.orderHistory.details', {
        orderId: this.state.productDetail.OrderId
      });
    }
  }, {
    key: "navigateToContentActivity",
    value: function navigateToContentActivity() {
      this.actions.stateGo(CONTENT_ACTIVITY_STATE, {
        productId: this.state.productDetail.Product.Id,
        previousRoute: {
          name: this.state.routeState.name,
          params: this.state.routeParams
        }
      }, {
        reload: true
      });
    }
  }, {
    key: "calculateTimeRemaining",
    value: function calculateTimeRemaining(expirationDate) {
      if (expirationDate) {
        var difference = moment(expirationDate).diff(moment());
        var duration = difference > 0 ? moment.duration(difference) : moment.duration(new Date());
        return i18n.translate(this.CustomerLocaleKeys.PRODUCTS_PAGE.TIME_REMAINING_DISPLAY, {
          Day: duration.days(),
          Hour: duration.hours(),
          Minute: duration.minutes()
        });
      } else {
        return null;
      }
    }
  }, {
    key: "getExpirationDate",
    value: function getExpirationDate(policies) {
      if (policies) {
        //this finds the expiration date from a list of purchase policies on a locker item
        var expirationDate = head(reject(isNil, pluck('ExpirationDate')(policies)));
        this.isExpired = moment(expirationDate).isBefore(moment());
        return expirationDate;
      }
    }
  }, {
    key: "hasAccessOrLicenseCount",
    value: function hasAccessOrLicenseCount(policies) {
      if (policies) {
        var accessCount = head(reject(isNil, pluck('AccessRequestsRemaining')(policies)));
        var licenseCount = head(reject(isNil, pluck('LicenseRequestsRemaining')(policies)));
        return accessCount || licenseCount;
      }
    }
  }, {
    key: "hasPolicyValue",
    value: function hasPolicyValue(policies) {
      return this.getExpirationDate(policies) || this.hasAccessOrLicenseCount(policies);
    }
  }, {
    key: "displayZeroWhenEmpty",
    value: function displayZeroWhenEmpty(property) {
      return property || i18n.translate(this.CustomerLocaleKeys.PRODUCTS_PAGE.ZERO);
    }
  }, {
    key: "canGrantAdditionalRights",
    value: function canGrantAdditionalRights() {
      return hasAccess(this.state.userSecurityAttributes, GRANT_ADDITIONAL_RIGHTS);
    }
  }, {
    key: "showAvailabilityDate",
    value: function showAvailabilityDate() {
      return new Date(pathOr(null, ['PricingPlan', 'AvailabilityStart'], this.state.productDetail)) > this.currentDateTime;
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnect();
    }
  }]);
}();
export default {
  template: require('./products.detail.html'),
  controller: ProductsDetailController,
  controllerAs: 'ProductsDetail'
};